if (!customElements.get('planted-toggler')) {
  // listen to click on [data-toggle] node
  // and toggle CSS classes for [data-toggle-open-class]
  class PlantedToggler extends HTMLElement {
    connectedCallback() {
      const toggleEl = this.querySelector('[data-toggle]')
      const self = this

      let isOpen = false
      const shouldLockScrollOnOpen = this.hasAttribute('data-lockscroll')
      const initialOverScroll = document.body.style.overflow

      toggleEl.addEventListener('click', function () {
        isOpen = !isOpen
        if (shouldLockScrollOnOpen) {
          if (isOpen) {
            document.body.style.overflow = 'hidden'
          } else {
            document.body.style.overflow = initialOverScroll
          }
        }

        self.querySelectorAll('[data-toggle-open-class]').forEach((el) => {
          const classes = el
            .getAttribute('data-toggle-open-class')
            .trim()
            .split(' ')
          classes.forEach(function (aClass) {
            if (aClass === '') {
              return
            }
            if (isOpen) {
              el.classList.add(aClass)
            } else {
              el.classList.remove(aClass)
            }
          })
        })
      })
    }
  }
  customElements.define('planted-toggler', PlantedToggler)
}
